import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Hyperlink,
  List,
  PageHeader,
  Typography,
} from 'br2s-ui-componentlibrary_r2_02';
import Container from '@/components/Container/Container';
import { ITEMS, ITEMS_THREE, ITEMS_TWO } from './terms-of-use-constants';
import '../FooterPage.scss';

type ListItemType = string | React.ReactElement;
export type ListItem =
  | ListItemType
  | {
      text: ListItemType;
      child: ListItem[] | React.ReactElement[];
    };

const renderSections = ({
  id,
  data,
}: {
  id: string;
  title: string;
  data: (
    | string
    | {
        text: string | React.ReactElement;
        child: ListItem[] | React.ReactElement[];
      }
  )[];
}) => (
  <div className="section" key={id}>
    <List maxList={100} id={`${id}-list`} type="alphanumeric" data={data} />
  </div>
);

const TermsOfUse = () => {
  const navigate = useNavigate();

  return (
    <div className="footer-page-container">
      <PageHeader
        id="terms-of-use"
        title="Terms of use"
        description="By accessing the ACRA bizfile website, you acknowledge the following Terms of Use."
        breadcrumbData={[
          {
            label: 'Home',
            onClick: () => navigate('/ '),
          },
          { label: 'Terms of use' },
        ]}
      />
      <Container>
        <div className="container">
          <div className="footer-page-content">
            <div className="part-one">
              <div className='parent-title'>
                <Typography
                  type="headline-3"
                  label="TERMS AND CONDITIONS OF USE OF BIZFILE (PART 1) "
                  weight="bold"
                />
              </div>
              <div className="section-part-one">
                {ITEMS.map(renderSections)}
              </div>
            </div>
            <div className="part-two">
              <div className='parent-title'>
                <Typography
                  type="headline-3"
                  label="ADDITIONAL TERMS AND CONDITIONS FOR PERFORMING A TRANSACTION THROUGH BIZFILE (PART 2) "
                  weight="bold"
                />
              </div>
              <div className="section-part-two">
                {ITEMS_TWO.map(renderSections)}
              </div>
            </div>
            <div className="part-three">
              <div className='parent-title'>
                <Typography
                  type="headline-3"
                  label="ADDITIONAL API TERMS OF USE"
                  weight="bold"
                />
              </div>
              <div className="section-part-three">
                {ITEMS_THREE.map(renderSections)}
              </div>
            </div>
            <div className="schedule-footer mt-3">
              <Typography type="base" label="SCHEDULE" weight="bold" />
              <Typography type="base" label="THIRD PARTY TERMS" />
              <Typography
                type="base"
                label="NOTE: These Third Party Terms are furnished here for your convenience only. It is your responsibility to ensure that you have read, understood and agreed to the most up-to-date versions of these Third Party Terms. "
              />
              <Typography
                type="base"
                label="Corppass Digital Services Terms of Use -"
              />
              <Hyperlink
                id="corppass-link"
                label={'https://www.corppass.gov.sg/corppass/common/terms'}
                href={'#'}
                isDisabled
              />
              <Typography
                type="base"
                label="Singpass Digital Services Terms of Use  -"
              />
              <Hyperlink
                id="singpass-link"
                label={'https://www.singpass.gov.sg/singpass/common/termsofuse'}
                href={'#'}
                isDisabled
              />
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default TermsOfUse;
